import Vue from 'vue'
import Vuex from 'vuex'
import lufei from './modules/lufei'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    lufei
  }
})
